export const ensureScript = (scriptId: string, scriptSrc: string) => {
  const existing = document.getElementById(scriptId) as HTMLScriptElement | null
  if (existing) return existing

  const script = document.createElement('script')
  script.id = scriptId
  script.src = scriptSrc
  script.async = true
  script.defer = true
  ;(document.head || document.body || document.documentElement).appendChild(script)
  return script
}
